import(/* webpackMode: "eager" */ "/vercel/path0/apps/shopify-plugin/src/app/(authorized)/[workspaceId]/page.tsx");
